import { useEffect, useState } from "react";
import { useCurrentUser, useCurrentUserLoading } from "../contexts/CurrentUserContext";
import { axiosReq } from "../api/axiosDefaults";

const SHORTTERM_GROUP = "shortterm_manager";

const buildStatus = (isStaff, isSuperuser, groups) => ({
  isStaff,
  isSuperuser,
  groups,
  canAccessListings: isSuperuser || (isStaff && !groups.includes(SHORTTERM_GROUP)),
  canAccessShortTerm: isSuperuser || groups.includes(SHORTTERM_GROUP),
  canApprove: isSuperuser,
});

const DENIED = buildStatus(false, false, []);

const useUserStatus = () => {
  const user = useCurrentUser();
  const isAuthLoading = useCurrentUserLoading();
  const [userStatus, setUserStatus] = useState(null);
  const userId = user?.pk;

  // Synchronous reset — if auth is done and no user, return DENIED immediately
  // without waiting for the async effect, preventing the admin navbar flash on logout
  const effectiveStatus = (!isAuthLoading && !userId) ? DENIED : userStatus;

  useEffect(() => {
    if (isAuthLoading) return;
    if (!userId) {
      setUserStatus(DENIED);
      return;
    }
    const getUserStatus = async () => {
      try {
        const { data } = await axiosReq.get(`user_status/`);
        const { is_staff, is_superuser, groups } = data.staff_status;
        setUserStatus(buildStatus(is_staff, is_superuser, groups || []));
      } catch (err) {
        setUserStatus(DENIED);
      }
    };
    getUserStatus();
  }, [userId, isAuthLoading]);

  return effectiveStatus;
};

export default useUserStatus;
